import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import MobileBureauLookupOutputComponent from '../output/MobileBureauLookupOutputComponent';

const MobileBureauLookupInputComponent = ({ serviceId, serviceDetails, leadId }) => (
    <SimpleReportForm
        serviceId={serviceId}
        serviceDetails={serviceDetails}
        leadId={leadId}
        banner={{ icon: 'pi-search', title: 'Mobile Bureau Lookup', subtitle: 'Cross-reference a mobile number with credit bureau records' }}
        fields={[
            { name: 'mobile', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
            { name: 'first_name', label: 'First Name', icon: 'pi-user', placeholder: 'Enter first name', maxLength: 50, autoCapitalize: 'words' },
            { name: 'pan', label: 'PAN (optional)', icon: 'pi-credit-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              required: false },
        ]}
        endpoint={{
            path: '/tartan/mobile-bureau/verify',
            bodyMapper: (v, sid, lid) => ({
                mobile_no: v.mobile,
                first_name: v.first_name.trim(),
                ...(v.pan && { pan: v.pan }),
                service_id: parseInt(sid, 10),
                api_provider_service_id: parseInt(sid, 10),
                ...(lid ? { lead_id: parseInt(lid, 10) } : {}),
            }),
        }}
        consentReportType="mobile-bureau"
        submitLabel="Lookup Bureau"
        successSummary="Mobile bureau lookup complete"
        errorSummary="Mobile bureau lookup failed"
        confirmHeader="Confirm mobile bureau lookup"
        confirmAcceptLabel="Yes, lookup"
        outputComponent={MobileBureauLookupOutputComponent}
    />
);

export default MobileBureauLookupInputComponent;
